<div class="bg-color-white rounded-md overlay-shadow p-2 w-[350px]">
  <div class="text-navy-700 font-semibold py-2 flex items-center gap-1">
    <!--    <app-back-button-box *ngIf="selectedTemplate" (clicked)="unselectTemplate()"></app-back-button-box>-->
    @if (selectedTemplate) {
      <app-bordered-dropdown-icon
        (click)="unselectTemplate()"
        [isClosed]="true"
        [useAsBackButton]="true"
      ></app-bordered-dropdown-icon>
    }
    <span class="text-sm">{{ selectedTemplate ? selectedTemplate.name : 'Please Select a Budget Template Tag' }}</span>
  </div>
  <ng-scrollbar #scrollbar class="std-scrollbar !max-h-48 min-h-[192px]" appearance="native" orientation="vertical">
    <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
      @if (hasTemplate) {
        <div
          (click)="removeTemplate()"
          class="text-blue-700 font-medium text-xs py-2 bottom-border flex-1 pointer-cursor"
        >
          Unlink Budget Template Tag
        </div>
      }

      @if (!selectedTemplate) {
        <div [ngClass]="{ 'bottom-border cursor-pointer': showAllTags && budgetTemplateTags?.length }" class="flex">
          @if (showAllTags) {
            <span (click)="selectAllTagsLocalOption.emit()" class="text-navy-700 font-medium text-xs py-2 flex-1"
              >All Tags
            </span>
          }
          @if (!budgetTemplateTags?.length && !showAllTags) {
            <div class="flex flex-1 h-full text-center pt-4 text-sm text-navy-500">
              Currently there are no budget template tags. Please create tag templates.
            </div>
          }
        </div>
        @for (template of budgetTemplateTags; track template) {
          <div class="flex items-center cursor-pointer bottom-border">
            <span (click)="selectTemplate(template)" class="text-navy-700 font-medium text-xs py-2 flex-1"
              >{{ template.name }}
            </span>
            <span class="icon-arrow-right-light text-blue-700"></span>
          </div>
        }
      } @else {
        @for (tag of selectedTemplate?.tags; track tag) {
          <div
            [ngClass]="{
              'pointer-events-none': tag.id | containsValue: disabledBudgetTagIds,
            }"
            class="w-full flex bottom-border"
            (click)="selectTag(tag)"
          >
            <span
              [ngClass]="{
                '!text-grey-600': tag.id | containsValue: disabledBudgetTagIds,
              }"
              class="text-navy-700 font-medium text-xs py-2 flex-1 cursor-pointer"
              >{{ tag.name }}</span
            >
          </div>
        }
      }
    </div>
  </ng-scrollbar>
</div>
